import http from '../../../utils/fetch';

export default {
    baseurl: '/api/swyl/v1/salesamplelist',
    baseur2: '/api/swyl/v1/demo',
    selectPage(query) {
        return http({
            url: this.baseurl + '/bscSalesSamplelist/selectPage',
            method: 'post',
            params: query
        });
    },
    selectById(v) {
        return http.post('/api/swyl/v1/salesamplelist/bscSalesSamplelist/selectById?id=' + v);
    },
    updateById(query) {
        return http({
            url: this.baseurl + '/bscSalesSamplelist/updateById',
            method: 'post',
            data: query
        });
    },
    toDelete(v) {
        return http.post('/api/swyl/v1/salesamplelist/bscSalesSamplelist/toDelete?id=' + v);
    },
    Listed(v) {
        return http.post('/api/swyl/v1/salesamplelist/bscSalesSamplelist/Listed?id=' + v);
    },
    below(v) {
        return http.post('/api/swyl/v1/salesamplelist/bscSalesSamplelist/below?id=' + v);
    },
    showprocategory(v){
        return http.post('/api/swyl/v1/productlevel/productLevel/showprocategory?id='+ v);
    },
    saveS(query){
        return http({
            url: this.baseurl + '/bscSalesSamplelist/insert',
            method: 'post',
            data: query
        });
    },
    selectUpdate(v){
        return http.post('/api/swyl/v1/salesamplelist/bscSalesSamplelistLog/selectUpdate?id='+ v);
    },
    toshow(pageId,nextShow){
        return http({
            url: '/api/swyl/v1/demo/bscNoviceGuideDetail/isShowNoviceGuide',
            method: 'post',
            params: {pageId,nextShow}
        });
    },
    selectCountPage(data){
        return http({
            url: '/api/swyl/v1/domestic/userReceDomestic/selectCountPage',
            method: 'post',
            params: data
        });
    },
    getUserAuth(){
        return http({
            url: '/api/swyl/v1/domestic/userReceDomestic/getUserAuth',
            method: 'post',
        });
    },
    selectDetailsPage(data){
        return http({
            url: '/api/swyl/v1/domestic/userReceDomestic/selectDetailsPage',
            method: 'post',
            params: data
        });
    },
    saveShow(pageId){
        return http({
            url: '/api/swyl/v1/demo/bscNoviceGuideDetail/saveShow',
            method: 'post',
            params: {pageId}
        });
    },
    selectModel(v) {
        return http.post('/api/swyl/v1/salesamplelist/bscSalesSamplelist/selectModel?prodcode=' + v);
    },
    expandCompanyShp(v) {
        return http.post('/api/swyl/v1/salesamplelist/bscSalesSamplelist/expandCompanyShp', v);
    },
    reSubmit(v) {
        return http.post('/api/swyl/v1/salesamplelist/bscSalesSamplelist/reSubmit', v);
    },
}
